import gql from 'graphql-tag';

export const byIntegrationItemKindCountFragment = gql`
  fragment byIntegrationItemKindCountFragment on ByIntegrationItemKindCount {
    integrationItemKind
    count
  }
`;
export default byIntegrationItemKindCountFragment;
